var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3236 11.7699C41.1058 10.8998 40.6623 10.1026 40.0378 9.45883C39.4133 8.81503 38.6299 8.34742 37.7669 8.10325C34.6136 7.33325 22.0002 7.33325 22.0002 7.33325C22.0002 7.33325 9.3869 7.33325 6.23357 8.17659C5.37052 8.42076 4.58719 8.88836 3.9627 9.53216C3.33821 10.176 2.89468 10.9732 2.6769 11.8433C2.09979 15.0434 1.8175 18.2898 1.83357 21.5416C1.813 24.8178 2.09531 28.089 2.6769 31.3133C2.91699 32.1563 3.37046 32.9232 3.9935 33.5398C4.61653 34.1564 5.38807 34.6019 6.23357 34.8333C9.3869 35.6766 22.0002 35.6766 22.0002 35.6766C22.0002 35.6766 34.6136 35.6766 37.7669 34.8333C38.6299 34.5891 39.4133 34.1215 40.0378 33.4777C40.6623 32.8339 41.1058 32.0367 41.3236 31.1666C41.8962 27.9905 42.1785 24.7689 42.1669 21.5416C42.1875 18.2653 41.9052 14.9942 41.3236 11.7699Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 27.5366L28.4167 21.5416L17.875 15.5466V27.5366Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.1f4463aedef257cb8da6d7c0253064e3.svg";
export { ForwardRef as ReactComponent };